exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scroll-mt-8 {\n  scroll-margin-top: 2rem;\n}\n", ""]);

// exports
